import * as types from 'yoda-account-components/lib/actionTypes/GroupActionTypes';

function GroupReducer(state = {}, action = {}) {
    switch (action.type) {
        case types.GET_EMAILID_BY_TOKEN:
            return {};

        case types.GET_EMAILID_BY_TOKEN_SUCCESS: {
            const emailToken = action.payload;

            return { ...state, emailToken };
        }

        case types.GET_EMAILID_BY_TOKEN_ERROR: {
            return { ...state, emailToken: { ...action.payload } };
        }

        case types.GET_REWARDS_PROFILE_ERROR:
        case types.GET_REWARDS_PROFILE_SUCCESS: {
            const profile = action.payload;
            return { ...state, profile };
        }

        default:
            return state;
    }
}

GroupReducer.reducerName = 'groupDetails';
export default GroupReducer;
